import { Download } from 'lucide-react';
import { Button } from '@hqo/ui-atoms';
import { useIntl } from 'react-intl';
import { useDownloadVisitorsTemplate } from '../../hooks/use-download-visitors-template';

export const VisitorTemplateDownloadButton = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const { handleDownloadTemplate } = useDownloadVisitorsTemplate();

  return (
    <Button
      type="button"
      variant="outline"
      onClick={handleDownloadTemplate}
      className="inline-flex items-center justify-center rounded-xl h-10 px-5 py-2 flex-1"
    >
      <Download className="h-4 w-4" />
      {formatMessage({ id: 'createVisitFormV2.visitStep.downloadTemplate', defaultMessage: 'Download template' })}
    </Button>
  );
};
